import { NgModule } from '@angular/core'
import { QuillModule } from 'ngx-quill'
import { CommonModule } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatSortModule } from '@angular/material/sort'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatChipsModule } from '@angular/material/chips'
import { MatMenuModule } from '@angular/material/menu'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatNativeDateModule } from '@angular/material/core'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatDialogModule } from '@angular/material/dialog'

import { NotificationManagementRoutingModule } from './notification-management-routing.module'
import { NotificationManagementContainerComponent } from './components/notification-management-container/notification-management-container.component'
import { NotificationListComponent } from './components/notification-list/notification-list.component'
import { NotificationFormDialogComponent } from './dialogs/notification-form-dialog/notification-form-dialog.component'
import { AppContainerModule } from '../../../../apps/keycom/src/app/app-container/app-container.module'
import { KeyingSharedModule } from '@overtur-monorepo/keying-shared'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatMenuModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatDialogModule,
    QuillModule.forRoot(),
    NotificationManagementRoutingModule,
    AppContainerModule,
    KeyingSharedModule,
  ],
  declarations: [
    NotificationManagementContainerComponent,
    NotificationListComponent,
    NotificationFormDialogComponent,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class NotificationManagementModule {}
